import { message } from "antd";
import axios from "axios";
import { apiHeaders } from "../helper/apiHeader";
import { setLocalStorage } from "../helper/localStorage";
import startDashboard from "../helper/startDashboard";


export const signUpApi = (value, dispatchLogin, history) => {
  const data = {
    data: value,
  };

  dispatchLogin({ type: "LOGIN_LOADER" });
  axios
    .post("/UserProfile", data, apiHeaders("register"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatchLogin({ type: "STUDENT_DATA", payload: res.data });
        startDashboard(history, res.data)
      } else {
        message.error(res.data.msg);
        dispatchLogin({ type: "LOGIN_ERR" });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatchLogin({ type: "LOGIN_ERR" });
    });
};